// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styles from './styles';

class ArrangeCollection extends React.Component {
  state = {};

  render() {
    const { classes } = this.props;
    return (
      <Link className={classes.container} to={'/arrange-collection'}>
        <h6 className={classes.textTitle}>ARRANGE A COLLECTION</h6>
        <p className={classes.textDescription}>From your home or workplace</p>
      </Link>
    );
  }
}

ArrangeCollection.propTypes = {
  classes: PropTypes.object,
};

ArrangeCollection.defaultProps = {
  classes: {},
};

export default withStyles(styles)(ArrangeCollection);
